import { kNewConversationTitle } from '@/chat-common/conversation_list/constants'
import { RootState } from '@/store/store'
import { createSelector } from '@reduxjs/toolkit'
import { selectConversationsByMatter } from '@/chat-common/conversation_list/selectors'

/**
 * Selector: Last Viewed Conversation ID By Matter
 * Returns the last viewed conversation ID for the given matter.
 * Returns null if no matter is selected.
 */
export const selectLastViewedConversationId = createSelector(
  (state: RootState) => state.conversationNavigationState,
  (_: RootState, props: { matterId: string | null }) => props.matterId,
  (navigationState, matterId) => {
    // No matter selected = no last viewed conversation
    if (!matterId) return null
    return navigationState.lastViewedByMatter[matterId] ?? null
  }
)

/**
 * Selector: Most Recent New Chat
 * Finds the current user's most recent "New Chat" placeholder for a given matter.
 *
 * Scoped to the current user because `selectConversationsByMatter` already drops other
 * members' "New Chat" placeholders (pass `currentUserId` in the props).
 */
export const selectMostRecentNewChat = createSelector(selectConversationsByMatter, (conversations) => {
  return conversations.find((conversation) => conversation.title === kNewConversationTitle) ?? null
})
